import { useAuthStore } from '@/stores/auth';

// MOCK_MODE=true (build-time, staging builds only — see rspack.config.mjs +
// deploy-web.yml) shows a "Sign in as Test User" option next to Google SSO.
// SSO sessions keep hitting the real API/DB; only the test-user session is
// served from in-memory fixtures (no API, no DB, no sockets).
//
// Keep this module light: the fixtures/handlers live in ./data and ./handlers
// and are only pulled in via dynamic import (see services/api.ts), so
// production bundles carry none of the mock data.
export const IS_MOCK_MODE = process.env.MOCK_MODE === 'true';

export const MOCK_TOKEN = 'mock-session-token';

export const MOCK_USER = {
	id: 'user-test-0001',
	email: 'test.user@canismajor.asia',
	name: 'Test User',
	role: 'super_admin'
};

/** True only while the current session belongs to the mock test user. */
export function isMockSession(): boolean {
	return IS_MOCK_MODE && useAuthStore.getState().token === MOCK_TOKEN;
}
